export enum SpinnerState {
    opaque = 'opaque',
    transparent = 'transparent',
    off = 'off',
}
